export default "__VITE_ASSET__r$efDcO___"